module.exports = __webpack_public_path__ + "static/featuredBlockLayout4Back-8dc6607269c9445a4c1494a9819d6163.png";